import classNames from 'classnames';
import { ReactNode } from 'react';

interface Props {
  title: string;
  children?: ReactNode;
}

const VenueContentBlock = ({ title, children }: Props) => {
  const classes = classNames({
    'venue-content-block': true,
    'venue-content-block--clinical': title === 'Clinical rooms',
    'venue-content-block--non-clinical': title === 'Non-Clinical rooms',
  });

  return (
    <div className={classes}>
      <div className="venue-content-block__container">
        <h3 className="venue-content-block__title">{title}</h3>
        <div className="venue-content-block__content">{children}</div>
      </div>
    </div>
  );
};

export default VenueContentBlock;
